module.exports = __webpack_public_path__ + "assets/pdf/malbec-reserva.ad11afbd.pdf";